import React, { useEffect, useState } from 'react';
import Loader from '../../../common/Loader';
import { getMe } from '../../../common/api';
import { UserContext } from '../../../common/UserContext';

const LOGIN_URL = `${process.env.REACT_APP_BACKEND_BASE_URL}/html/login`;

// Guard delle pagine admin: carica l'utente corrente (email e ruolo) e rimanda al login se la sessione non è valida
function Auth({ children }) {
  const [user, setUser] = useState(null);

  useEffect(() => {
    getMe()
      .then(setUser)
      .catch((error) => {
        console.error("Errore durante il controllo dell'autenticazione:", error);
        window.location.href = LOGIN_URL;
      });
  }, []);

  if (!user) {
    return <Loader />;
  }

  return <UserContext.Provider value={user}>{children}</UserContext.Provider>;
}

export default Auth;
